import { Link, Outlet, useLocation } from 'react-router-dom';

import ScrollNav from '@/components/ui/scroll-nav';
import type { ScrollNavItem } from '@/components/ui/scroll-nav';
import { Button } from '@/components/ui/button';
import PageContentTransition from '@/components/page-content-transition';

export default function SettingsLayout() {
  const location = useLocation();

  const navItems: ScrollNavItem[] = [
    { label: 'General', id: '/profile/settings/general' },
    {
      label: 'Notifications',
      id: '/profile/settings/notifications',
    },
    { label: 'Privacy', id: '/profile/settings/privacy' },
    {
      label: 'Preferences',
      id: '/profile/settings/preferences',
    },
  ];

  return (
    <div className="z-10 mx-4 mt-4 mb-12 flex flex-col gap-5 sm:mx-12 sm:gap-4">
      <ScrollNav
        items={navItems}
        showBorder={true}
        scrollContainerClassName="mb-2"
        renderItem={(item: ScrollNavItem) => {
          const isActive = item.id === location.pathname;
          return (
            <Button
              className="flex w-max"
              key={item.id}
              variant={isActive ? 'default' : 'ghost'}
              asChild
            >
              <Link to={item.id}>{item.label}</Link>
            </Button>
          );
        }}
      />

      <PageContentTransition>
        <Outlet />
      </PageContentTransition>
    </div>
  );
}
